import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_DEVICE_ORDER_PLAN_OPTIONS_API,
    GET_DEVICE_ORDER_PLAN_OVERVIEW_API,
    POST_DEVICE_ORDER_PLAN_API,
    PUT_DEVICE_ORDER_PLAN_API,
    DELETE_DEVICE_ORDER_PLAN_API,
    PUT_DEVICE_ORDER_PLAN_ENABLE_API,
} from '@Apis/apiPath';

const useDeviceOrderPlanApi = () => {
    const Axios = useAxios();

    const getDeviceOrderPlanOptionsApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_DEVICE_ORDER_PLAN_OPTIONS_API);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const getDeviceOrderPlanOverviewApi = useCallback(
        async (params) => {
            const resp = await Axios.get(GET_DEVICE_ORDER_PLAN_OVERVIEW_API, params);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const postDeviceOrderPlanApi = useCallback(
        async (params) => {
            const resp = await Axios.post(POST_DEVICE_ORDER_PLAN_API, params);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const putDeviceOrderPlanApi = useCallback(
        async (planID, params) => {
            const resp = await Axios.put(PUT_DEVICE_ORDER_PLAN_API(planID), params);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const deleteDeviceOrderPlanApi = useCallback(
        async (planID) => {
            const resp = await Axios.delete(DELETE_DEVICE_ORDER_PLAN_API(planID));
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const putDeviceOrderPlanEnableApi = useCallback(
        async (planID, params) => {
            const resp = await Axios.put(PUT_DEVICE_ORDER_PLAN_ENABLE_API(planID), params);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    return {
        getDeviceOrderPlanOptionsApi,
        getDeviceOrderPlanOverviewApi,
        postDeviceOrderPlanApi,
        putDeviceOrderPlanApi,
        deleteDeviceOrderPlanApi,
        putDeviceOrderPlanEnableApi
    };
};

export default useDeviceOrderPlanApi;
